// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__c6omE","footer":"ModalInfo_footer__3yZGE"};